import { Breadcrumb, Grid } from "semantic-ui-react";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { observable } from "mobx";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import Link from "~/components/element/Link";
import RouteWrapper from "~/components/wrapper/RouteWrapper";
import ContentLoader from "~/components/element/ContentLoader";
import ToastMessageStore from "~/stores/ToastMessageStore";
import ToastMessageContainer from "~/components/ToastMessageContainer";
import InvoiceStore from "~/stores/Invoice/InvoiceStore";
import PaginatedTable from "~/components/PaginatedTable";
import InvoiceCard from "~/modules/BillingCentral/components/InvoiceCard";
import SubscriptionStore from "~/stores/Subscription/SubscriptionStore";
import InvoiceIndexHeader from "~/modules/BillingCentral/components/InvoiceIndexHeader";

@observer
class InvoiceIndexPage extends Component {
  @observable invoiceStore = null;

  @observable subscriptionStore = null;

  constructor(props) {
    super(props);

    const { t } = props;

    document.title = t("billingCentral:invoices");

    this.invoiceStore = new InvoiceStore();
    this.subscriptionStore = new SubscriptionStore();
  }

  componentDidMount() {
    const { showError, query, t } = this.props;

    if (typeof query.subscriptionId === "undefined" || Number.isNaN(parseInt(query.subscriptionId, 10))) {
      showError(t("billingCentral:subscriptionIdIsRequired"));

      return;
    }

    this.loadInvoices(parseInt(query.subscriptionId, 10));

    this.subscriptionStore.pagination.itemsPerPage = 100;
    this.subscriptionStore.loadIndex().catch(error => showError(error.message));
  }

  loadInvoices(subscriptionId) {
    const { showError } = this.props;

    this.invoiceStore.searchParams.subscriptionId = subscriptionId;
    this.invoiceStore.loadIndex().catch(error => showError(error.message));
  }

  render() {
    const { t, toastMessageStore, showError, replaceQuery, redirectTo } = this.props;
    const { isLoading: invoiceLoading, invoices, pagination, searchParams } = this.invoiceStore;
    const { subscriptionId: filterBySubscriptionId } = searchParams;
    const { isLoading: subscriptionLoading, subscriptions } = this.subscriptionStore;

    if (subscriptionLoading) {
      return <ContentLoader />;
    }

    return (
      <>
        <div className="side-page-outer-container">
          <Breadcrumb>
            <Breadcrumb.Section>
              <Link to="/billing-central">{t("billingCentral:billingCentral")}</Link>
            </Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>{t("billingCentral:invoices")}</Breadcrumb.Section>
          </Breadcrumb>

          <InvoiceIndexHeader
            subscriptions={subscriptions}
            subscriptionId={filterBySubscriptionId}
            filterBySubscriptionId={subscriptionId => {
              this.loadInvoices(subscriptionId);
              replaceQuery({ subscriptionId });
            }}
          />

          <Grid centered className="main-grid">
            <Grid.Column>
              {invoiceLoading ? (
                <ContentLoader />
              ) : (
                <PaginatedTable
                  pagination={pagination}
                  changePageCallback={page => {
                    this.invoiceStore.changePage(page).catch(error => showError(error.message));
                    replaceQuery({ subscriptionId: filterBySubscriptionId, page });
                  }}
                  totalItemsCount={invoices.length}
                >
                  <>
                    {invoices.length > 0 ? (
                      invoices.map(invoice => (
                        <InvoiceCard
                          key={invoice.invoiceId}
                          invoice={invoice}
                          redirectToInvoiceViewPageCallback={invoiceId =>
                            redirectTo(`/billing-central/invoices/${invoiceId}`)
                          }
                        />
                      ))
                    ) : (
                      <p>{t("billingCentral:noInvoices")}</p>
                    )}
                  </>
                </PaginatedTable>
              )}
            </Grid.Column>
          </Grid>
        </div>
        <ToastMessageContainer toastMessageStore={toastMessageStore} />
      </>
    );
  }
}

InvoiceIndexPage.propTypes = {
  showError: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
};

export default withTranslation()(ErrorWrapper(RouteWrapper(InvoiceIndexPage)));
